import { render } from "./btcWaitingPayment.vue?vue&type=template&id=7c5ee0e0&scoped=true"
import script from "./btcWaitingPayment.vue?vue&type=script&lang=js"
export * from "./btcWaitingPayment.vue?vue&type=script&lang=js"

import "./btcWaitingPayment.vue?vue&type=style&index=0&id=7c5ee0e0&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5ee0e0"]])

export default __exports__